import {MspRegionActions, RegionMspActionTypes, MspRegionFilterActions, MspRegionFilterActionTypes} from '../actions/region-msp.actions';
import {MspRegion} from '../region.model';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';


export interface State extends EntityState<MspRegion> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<MspRegion> = createEntityAdapter<MspRegion>({
  selectId: region => region.Id
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false,
});

export function reducer(state = initialState, action: MspRegionActions): State {
  switch (action.type) {
    case RegionMspActionTypes.GetMspRegions:
      return {...state, Loaded: false, Loading: true};

    case RegionMspActionTypes.GetMspRegionSuccess:
      return adapter.setAll(action.payload, {
        ...state,
        Loaded: true,
        Loading: false,
      });

    case RegionMspActionTypes.AddMspRegion:
      return {...state, Loaded: false, Loading: true};

    case RegionMspActionTypes.UpdateMspRegion:
      return adapter.updateOne(action.payload, state);

    default:
      return state;
  }
}

export interface MspRegionFilterState {
  Loaded: boolean;
  RegionIds: number[];
}

export const initialMspRegionFilterState: MspRegionFilterState = {
  Loaded: false,
  RegionIds: []
};

export function MspRegionFilterreducer(state = initialMspRegionFilterState, action: MspRegionFilterActions): MspRegionFilterState {
  switch (action.type) {

    case MspRegionFilterActionTypes.SelectMspRegionFilters:
      return {...state, Loaded: true, RegionIds: action.payload};

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
